module.exports = __webpack_public_path__ + "img/logo-chiapas.c9106a51.png";